import { useState, useEffect } from "react";
import { rpcCall } from "../ws/client";

export function useMaintenance() {
    const [maintenanceEnabled, setMaintenanceEnabled] = useState<boolean>(false);
    const [maintenanceMessage, setMaintenanceMessage] = useState<string>("");

    useEffect(() => {
        // Check immediately (non-blocking)
        checkMaintenance();
        
        // Check every 30 seconds
        const interval = setInterval(checkMaintenance, 30000);
        return () => clearInterval(interval);
    }, []);

    async function checkMaintenance() {
        try {
            console.log("🔍 Checking maintenance status...");
            const result = await rpcCall("system.maintenance_status", {}) as any;
            const data = result.result || result;
            
            console.log("✅ Maintenance status:", data);
            setMaintenanceEnabled(data.enabled || false);
            setMaintenanceMessage(data.message || "");
        } catch (err) {
            console.error("❌ Error checking maintenance status:", err);
            // On error, assume no maintenance
            setMaintenanceEnabled(false);
        }
    }

    return {
        maintenanceEnabled,
        maintenanceMessage
    };
}
